import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tabs, Tab } from '@mui/material';
import AppointmentTable from './Appointment/AppointmentTable';
import DiagnosisDetail from './DiagnosisDetail';
import VitalsPanel from './VitalsPanel';
import DevicePanel from './DevicePanel';

export default function PatientDetails() {
  const { state } = useLocation();
  const patient = state;
  const [tabIndex, setTabIndex] = useState(0);

  if (!patient) return <div>No patient data found.</div>;

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const fallbackEmergencyContact = {
    name: 'Not Provided',
    relation: 'Unknown',
    phone: 'N/A',
  };
  const contact = patient.emergencyContact || fallbackEmergencyContact;

  return (
    <>
      {/* ========== TOP SECTION (3 Cards) ========== */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '20px',
          padding: '20px',
          fontFamily: 'Quicksand, sans-serif',
          boxSizing: 'border-box',
        }}
      >
        {/* ---------- Left Card - Profile ---------- */}
        <div
          style={{
            background: '#fff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            textAlign: 'center',
          }}
        >
          <img
            src={patient.avatar}
            alt="avatar"
            width={80}
            height={80}
            style={{ borderRadius: '50%', objectFit: 'cover' }}
          />
          <h2>{patient.name}</h2>
          <p>
            <strong>Member Status:</strong>{' '}
            <span style={{ color: 'green' }}>Active</span>
          </p>
          <p>
            <strong>Appointments:</strong> {patient.appointments || '0'}
          </p>
          <p>
            <strong>Payment Made:</strong> ${patient.payment || '320.00'}
          </p>
          <button
            style={{
              marginTop: '10px',
              padding: '6px 12px',
              background: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Send Message
          </button>
        </div>

        {/* ---------- Middle Card - Personal Info ---------- */}
        <div
          style={{
            background: '#fff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          <div><strong>ID:</strong> {patient.id}</div>

          {/* FIXED DOB FIELD */}
          <div><strong>DOB:</strong> {patient.dob ? new Date(patient.dob).toLocaleDateString("en-US") : "N/A"}</div>

          <div><strong>Gender:</strong> {patient.gender}</div>
          <div><strong>Age:</strong> {patient.age}</div>
          <div><strong>Blood Group:</strong> {patient.bloodGroup || "-"}</div>
          <div><strong>Insurance:</strong> {patient.insurance || "-"}</div>
          <div>
            <strong>Register Date:</strong>{" "}
            {patient.registerDate
              ? new Date(patient.registerDate).toLocaleDateString("en-US")
              : "N/A"}
          </div>
          <div><strong>Phone:</strong> {patient.contact}</div>
          <div><strong>Email:</strong> {patient.email}</div>
          <div><strong>Address:</strong> {patient.address}</div>
        </div>

        {/* ---------- Right Card - Emergency & Reports ---------- */}
        <div
          style={{
            background: '#fff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <div style={{ marginBottom: '20px' }}>
            <h4>Emergency Contact Information</h4>
            <p><strong>Name:</strong> {contact.name}</p>
            <p><strong>Relation with patient:</strong> {contact.relation}</p>
            <p><strong>Phone:</strong> {contact.phone}</p>
          </div>

          <div>
            <h4 style={{ display: 'flex', justifyContent: 'space-between' }}>
              Reports <span style={{ color: '#007bff', cursor: 'pointer' }}>+ Add Reports</span>
            </h4>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { name: 'CheckUp Result', date: '12/12/2025' },
                { name: 'Blood Test Report', date: '04/08/2025' },
                { name: 'CheckUp Result', date: '01/15/2025' },
                { name: 'X-ray', date: '08/12/2024' },
              ].map((report, idx) => (
                <div
                  key={idx}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '4px',
                  }}
                >
                  <div>
                    <strong>{report.name}</strong>
                    <p style={{ fontSize: '12px', margin: 0 }}>{report.date}</p>
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button style={{ cursor: 'pointer' }}>📄</button>
                    <button style={{ cursor: 'pointer' }}>🔍</button>
                    <button style={{ cursor: 'pointer' }}>🗑️</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ========== TAB SECTION ========== */}
      <div
        style={{
          background: '#fff',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          margin: '20px',
        }}
      >
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="Appointments Details" />
          <Tab label="Diagnosis" />
          <Tab label="Patient Engagement" />
          <Tab label="Add Device & Vital Risk Thresholds" />
          <Tab label="Vital Details" />
        </Tabs>

        <div style={{ marginTop: '20px' }}>
          {tabIndex === 0 && <AppointmentTable />}
          {tabIndex === 1 && <DiagnosisDetail />}
          {tabIndex === 2 && <p>No engagement data available yet.</p>}
          {tabIndex === 3 && <DevicePanel />}
          {tabIndex === 4 && <VitalsPanel username={patient?.username} />}
        </div>
      </div>
    </>
  );
}
